import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { CommodityFormComponent } from '../commodity-form/commodity-form.component';
import { ICommodity, ICommodityCriteria } from '../commodity-interface';
import { Message } from 'src/app/shared/constants/message';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-commodity-view',
    templateUrl: './commodity-view.component.html',
    styleUrls: ['./commodity-view.component.less'],
    standalone: false
})
export class CommodityViewComponent implements OnInit, AfterViewInit, OnDestroy {

  commodityForm: FormGroup;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalRecords:number;
  criteria: ICommodityCriteria = {};
  permissions = [];
	addPermission : boolean = false;
	editPermission : boolean = false;
	viewPermission : boolean = false;
  groupColumns = ['name','commodityType','hsCode','commodityGroup','imdgClass', 'imdgClassName','action'];
  commodityTypes:any=[];
  commodityGroups:any=[];
	subscription = new Subscription();

  public dataSource = new MatTableDataSource<ICommodity>();

  constructor(  private service: DataService, private formBuiler: FormBuilder, private dialog: MatDialog,
                private utilityService: UtilityService, private permissionService:PermissionService) { }

                
  ngAfterViewInit(): void {
    this.dataSource.sort=this.sort;
    this.dataSource.paginator=this.paginator;
		this.paginator?.page?.pipe(tap(() => this.getCommodities())).subscribe();
		this.getCommodities();
  }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.getCommodityTypes();
    this.getCommodityGroups();
    this.nameValueChangeEvent();
    this.hsCodeValueChangeEvent();
    this.commodityTypeValueChangeEvent();
    this.commodityGroupValueChangeEvent();
    this.imdgClassValueChangeEvent();
    this.imdgClassNameValueChangeEvent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private initializeForm() {
    this.commodityForm = this.formBuiler.group({
      name: [null],
      commodityType: [null],
      hsCode: [null],
      commodityGroup: [null],
      imdgClass: [null],
      imdgClassName: [null],
      parentId:[],
    });
  }

  private getCommodities(resetPageIndex: boolean =false){
    if (resetPageIndex) {
      this.paginator.pageIndex = 0;
    }
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    if(this.viewPermission){
      this.service.get(Api.COMMODITY, this.criteria).subscribe(res => {
        if(res){
          if(res.contents.length==0){
             this.utilityService.notifier('No Records Found','info');
          }
          this.dataSource = res.contents;
          this.totalRecords = res.totalRecords;
          if (this.paginator.pageIndex >= Math.ceil(res.totalRecords / this.paginator.pageSize)) {
            this.paginator.pageIndex = 0;
          }
        }
      });
    } else
        this.utilityService.notifier(Message.VIEW_PERMISSION_WARNING,"warning");
  }

  sortData(event: { active: string; direction: string; }){
		this.criteria.sort = [event.active, event.direction];
		this.getCommodities(true);
	}

  nameValueChangeEvent(){
    this.subscription = this.commodityForm.get('name').valueChanges.subscribe(commodityName => {
      this.criteria['name.contains']=commodityName;
      this.getCommodities(true);
	   });
  }

  hsCodeValueChangeEvent(){
    const sub = this.commodityForm.get('hsCode').valueChanges.subscribe(commodityHsCode => {
      this.criteria['hsCode.contains']=commodityHsCode;
      this.getCommodities(true);
	   });
     this.subscription.add(sub);
	}

  imdgClassValueChangeEvent(){
    const sub = this.commodityForm.get('imdgClass').valueChanges.subscribe(commodityImdgClass => {
      this.criteria['imdgClass.contains']=commodityImdgClass;
      this.getCommodities(true);
	  });
    this.subscription.add(sub);
	}

  imdgClassNameValueChangeEvent(){
    const sub = this.commodityForm.get('imdgClassName').valueChanges.subscribe(commodityImdgClassName => {
      this.criteria['imdgClassName.contains']=commodityImdgClassName;
      this.getCommodities(true);
	  });
    this.subscription.add(sub);
	}

  commodityTypeValueChangeEvent(){
    const sub = this.commodityForm.get('commodityType').valueChanges.subscribe(commodityType => {
      this.criteria['commodityType']=commodityType;
      this.getCommodities(true);
	  });
    this.subscription.add(sub);
	}

  commodityGroupValueChangeEvent(){
    const sub = this.commodityForm.get('commodityGroup').valueChanges.subscribe(commodityGroup => {
      this.criteria['commodityGroup']=commodityGroup;
      this.getCommodities(true);
	  });
    this.subscription.add(sub);
	}

  openForm(row?: any): void {
    if(!this.addPermission && !row)
      return this.utilityService.notifier(Message.ADD_PERMISSION_WARNING,"warning");
    if(!this.editPermission && row)
      return this.utilityService.notifier(Message.EDIT_PERMISSION_WARNING,"warning");
    const dailogRef = this.dialog.open(CommodityFormComponent, { data: row });
    dailogRef.afterClosed().subscribe(() => this.getCommodities());
  }

  getCommodityTypes(){
    this.service.get(Api.COMMODITY_TYPES).subscribe(res => {
      this.commodityTypes.push({key: "", label: "Search by Type"});
      this.commodityTypes.push(...res);
    });
  }

  getCommodityGroups(){
    this.service.get(Api.COMMODITY_GROUPS).subscribe(res => {
      this.commodityGroups.push({key: "", label: "Search by Group"});
      this.commodityGroups.push(...res);
    });
  }

  public checkAllPermission(){
    const permissionCodes=[PermissionKey.COMMODITY_MODULE_ADD_PERMISSION,PermissionKey.COMMODITY_MODULE_VIEW_PERMISSION,PermissionKey.COMMODITY_MODULE_EDIT_PERMISSION];
    const permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.COMMODITY_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.COMMODITY_MODULE_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.COMMODITY_MODULE_VIEW_PERMISSION})?.show?true:false; 
    this.editPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.COMMODITY_MODULE_EDIT_PERMISSION})?.show?true:false; 
  }

}
